import './src/styles/global.css'
import './src/styles/lazyLoading.css'
import 'slick-carousel/slick/slick.css'

export const onClientEntry = () => {
  if (typeof window === 'undefined') return;

  // ── 1. Kill ALL service workers and caches unconditionally ───────────────
  // This site does NOT use gatsby-plugin-offline (removed from config).
  // Any previously registered SW — same-origin or cross-origin — is stale
  // and must be removed. Previously this only cleaned up cross-origin SWs,
  // leaving same-origin ones (from when gatsby-plugin-offline was active)
  // intact, which caused blank pages after deploys when hashed JS filenames
  // changed but the old SW still referenced them.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((reg) => reg.unregister());
    });
  }

  if ('caches' in window) {
    caches.keys().then((cacheNames) => {
      cacheNames.forEach((cacheName) => caches.delete(cacheName));
    });
  }

  // ── 2. Self-healing: catch chunk-load failures and force clean reload ───
  // If a JS chunk returns 404 (e.g. from a stale SW referencing old hashes),
  // the page would show a blank screen. This handler detects that and does a
  // hard reload with cache bypass. Only fires once per session to avoid loops.
  window.addEventListener('error', (event) => {
    const target = event.target;
    if (
      target &&
      target.tagName === 'SCRIPT' &&
      target instanceof HTMLScriptElement &&
      target.src &&
      (target.src.includes('component---') || target.src.includes('webpack-runtime'))
    ) {
      const src = target.src;
      if (!sessionStorage.getItem('__sw_heal_reloaded')) {
        sessionStorage.setItem('__sw_heal_reloaded', '1');
        console.warn('[SW heal] Chunk load failed:', src, '— forcing reload');
        window.location.reload();
      }
    }
  }, true);

  // ── 3. Suppress noisy third-party widget console output ──────────────────
  // The WhatsApp/CRM integration-plugin.js and widget-plugin-dev.js log
  // verbose internal state (BTN linkId, before/after Objects, Loaded script).
  // These are harmless but pollute the console — filter them out.
  const SUPPRESSED = ['integration-plugin', 'widget-plugin', 'Loaded script', 'installingWorker'];
  const _log = console.log.bind(console);
  const _warn = console.warn.bind(console);
  console.log = (...args) => {
    const str = args.map(String).join(' ');
    if (SUPPRESSED.some((s) => str.includes(s))) return;
    _log(...args);
  };
  console.warn = (...args) => {
    const str = args.map(String).join(' ');
    if (SUPPRESSED.some((s) => str.includes(s))) return;
    _warn(...args);
  };

  // ── 4. Load Cloudflare Turnstile script once globally ───────────────────
  // In development, Turnstile uses Cloudflare's official test key (configured in
  // src/config/turnstileConfig.ts) so the widget renders without 401 errors on localhost.
  const TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  if (!document.querySelector(`script[src^="https://challenges.cloudflare.com/turnstile"]`)) {
    const script = document.createElement('script');
    script.src = TURNSTILE_SRC;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
};